<template>
  <div class="parkingViolationsCheck">
    <div class="carInfo">
      <div class="title">
        <div class="tit">违章信息</div>
        <div class="orderList" @click="goOrder">我的订单</div>
      </div>
      <div class="carContent">
        <div class="header">
          <div class="carNo">{{carData.carNo}}</div>
          <div class="changeCar" @click="changeCar"><img src="@/assets/img/ticket/changeCar.png" alt=""> 切换车辆</div>
        </div>
        <div class="carNum">
          <van-row>
            <van-col span="8" class="textVal">{{carInfoData.unProcess}}</van-col>
            <van-col span="8" class="textVal">{{carInfoData.totalPoints}}</van-col>
            <van-col span="8" class="textVal">{{carInfoData.totalAmount}}</van-col>
            <van-col span="8" class="textName">违章数</van-col>
            <van-col span="8" class="textName">需扣分</van-col>
            <van-col span="8" class="textName">需罚款</van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="textInfo">
      <div>本服务由江苏欧飞电子商务有限公司提供</div>
      <div class="info" v-if="!isShow">点击下方按钮进行查询</div>
      <div class="info" v-if="isShow">查询时间：{{nowTime}}</div>
    </div>
    <div class="noData" v-if="hasRequestList && carInfoData.violationInfoList.length <= 0">
      <div class="pic_default">
        <img src="@/assets/img/ticket/pic_default.png" alt="">
      </div>
      <div class="noDataInfo">暂无待办理的违章信息</div>
      <div class="goInfo" @click="goTicketCheck">《处罚决定书》请前往罚单缴费办理></div>
    </div>
    <div class="dataList" v-if="isShow">
      <div class="list" v-for="(item, index) in carInfoData.violationInfoList" :key="index">
        <div class="contentHeader">
          <van-checkbox v-model="item.checked" @click="checkChange(item)" :disabled="!(item.canSelect && item.processStatus === '1')" class="checked">{{item.province}}{{item.city}}</van-checkbox>
          <div class="number">罚款￥{{item.violateAmount}}  记{{item.point}}分</div>
        </div>
        <div class="contentInfo">
          <van-row>
            <van-col span="6" class="textNo">违法原因：</van-col>
            <van-col span="18" class="textVal">{{item.violateReason}}</van-col>
            <van-col span="6" class="textNo">违法地点：</van-col>
            <van-col span="18" class="textVal">{{item.violateAddr}}</van-col>
            <van-col span="6" class="textNo">违法时间：</van-col>
            <van-col span="18" class="textVal">{{item.violateDate}}</van-col>
          </van-row>
          <van-row v-if="!(item.canSelect && item.processStatus === '1')">
            <van-col class="textNo" style="color:#F29254">当前违章不可在线处理</van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button type="info" size="large" v-if="isCheck && cityData" @click="carListClick">查询违章</van-button>
    </div>
    <div class="btnBottom" v-if="isShow">
      <div class="number">罚款<span>￥{{total.violateAmount}}</span> 记<span>{{total.point}}</span>分</div>
      <van-button type="info" :disabled="disabled" @click="goParkingViolationsPay">立即处理</van-button>
    </div>
    <!-- 添加车辆 -->
    <add-car :showAddCar="showAddCar" :carList="carDataList" @cancel="cancelAddCar" @changeCar="carChange"></add-car>
    <!-- 驾驶证信息弹框 -->
    <car-info :isPointDeal="isPointDeal" @submit="carInfoSubmit" @close="isPointDeal = false"></car-info>
    <!-- 上传驾驶证 -->
    <driving-permits :isDriving="isDriving" @submit="drivingSubmit" @close="isDriving = false"></driving-permits>
  </div>
</template>
<script>
import AddCar from './components/addCar.vue'
import CarInfo from './components/carInfo.vue'
import DrivingPermits from './components/drivingPermits.vue'
import { carList, getCity, getCarInfo, getThirdPayment, findProductList} from "@/common/api.js";
import dayjs from "dayjs";
export default {
  name: "parkingViolationsCheck",
  components: {
    AddCar,
    CarInfo,
    DrivingPermits
  },
  data() {
    return {
      checked: false,
      isShow: false,
      carDataList: [],
      carData: {},
      cityData: {},
      isCheck: true,
      carInfoData: {
        totalAmount: 0,
        totalPoints: 0,
        unProcess: 0,
        violationInfoList: []
      },
      total: {
        violateAmount: 0,
        point: 0
      },
      showAddCar: false,
      checkedData: {},
      isPointDeal: false,
      isDrivingLicense: false,
      isDriving: false,
      carInfoObj: {},
      services: {},
      nowTime: '',
      hasRequestList: false // 是否已经点击查询
    }
  },
  computed: {
    disabled() {
      return !(this.total.violateAmount > 0 || this.total.point > 0)
    }
  },
  watch: {
    'carInfoData.violationInfoList'(val) {
      console.log(val);
      if(val.length) {
        this.isCheck =  false
        this.isShow = true
      }else{
        this.isCheck =  true
        this.isShow = false
      }
    }
  },
  created() {
    Promise.all([this.findProductList()]).then((values) => {
      this.getCarList()
    });
  },
  methods: {
    async findProductList() {
      const data = {
        categoryCodeList: [this.$route.query.categoryCode],
        pageNum: 1,
        pageSize: 10,
      }
      const res = await findProductList(data)
      this.services = res.list[0]
    },
    async getCity() {
      let data = {
        carNo: this.carData.carNo,
        productCode: this.services.productCode
      }
      try {
        const res = await getCity(data)
        this.cityData =  res
      } catch (error) {
        this.cityData =  null
      }
      
    },
    carListClick() {
      this.getCarInfo()
    },
    async getCarList() {
      const res = await carList({phone: this.$route.query.phone})
      this.carDataList = res;
      this.carData = res[0]
      console.log(res, 'res');
      
      this.getCity()
    },
    async getCarInfo(){
      if(!this.cityData){
        this.$toast('查询失败')
        return
      }
      this.$toast.loading({
        message: "查询中",
        forbidClick: true,
        duration: 0,
      })
      let data = {
        carNo: this.carData.carNo,
        numberPlateType: this.carData.numberPlateType,
        engineNo: this.carData.engineNo,
        vinNo: this.carData.vinNo,
        phone: this.carData.phone,
        productCode: this.services.productCode,
        engineNoLength: this.cityData.engineNoLength,
        vinNoLength: this.cityData.vinLength,
        city: this.cityData.city
      }
      const res = await getCarInfo(data)
      this.carInfoData = res
      this.carInfoData.violationInfoList && this.carInfoData.violationInfoList.forEach(item =>{
        this.$set(item, 'checked', false)
      })
      this.hasRequestList = true
      this.nowTime = new Date().Format('yyyy-MM-dd hh:mm:ss')
      this.$toast.clear()
    },
    checkChange(data) {
      let checkedList = []
      this.carInfoData.violationInfoList.forEach(item =>{
        if(item.providerOrderNo !== data.providerOrderNo){
          this.$set(item, 'checked', false)
        }
        if(item.checked) {
          checkedList.push(item)
        }
      })
      this.checkedData = checkedList[0]
      this.total.violateAmount = this.checkedData ? this.checkedData.violateAmount : 0
      this.total.point = this.checkedData ? this.checkedData.point : 0
    },
    changeCar() {
      this.showAddCar = true
    },
    cancelAddCar() {
      this.showAddCar = false
    },
    async getThirdPayment() {
      const data = {
        carNo: this.carData.carNo,
        productCode: this.services.productCode,
        city: this.cityData.city
      }
      const res = await getThirdPayment(data)
      // 判断pointDeal
      if (res.pointDeal) {
        // pointDeal为true
        if(this.total.point > 0){
          // 有记分
          this.isPointDeal = true;
          this.isDrivingLicense = res.drivingLicense
        }
      } else {
        // pointDeal为false
        if (this.total.point > 0) {
          // 有记分
          // 提示
          this.$toast('当前车辆归属地暂不支持在线扣分办理')
        }
      }
      // 判断drivingLicense
      if (this.total.point <= 0) {
        // 无记分
        if(res.drivingLicense) {
          // drivingLicense为true
          // 弹窗上传行驶证图片
          this.isDriving = true
        }else{
          // drivingLicense为false
          // 去支付
          this.drivingSubmit({})
        }
      }
    },
    carInfoSubmit(val) {
      this.isPointDeal = false
      this.carInfoObj = val
      if(this.isDrivingLicense){
        this.isDriving = this.isDrivingLicense
      }else{
        const data = {...val, ...this.checkedData, ...this.carData }
        this.$router.push({
          path: '/parkingViolationsPay',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode,
            productCode: this.services.productCode,
            formData: JSON.stringify(data)
          },
        });
      }
    },
    drivingSubmit(val) {
      this.isDriving = false
      const data = {...val, ...this.carInfoObj, ...this.checkedData, ...this.carData}
      this.$router.push({
          path: '/parkingViolationsPay',
          query: {
            phone: this.$route.query.phone,
            categoryCode: this.$route.query.categoryCode,
            productCode: this.services.productCode,
            formData: JSON.stringify(data)
          },
        });
    },
    goParkingViolationsPay() {
      console.log(this.checkedData);
      if(this.checkedData){
        this.getThirdPayment()
      }
    },
    goOrder() {
      this.$router.push({
        path: '/orderList',
        query: {
          phone: this.$route.query.phone,
          categoryName: this.services.categoryName,
          categoryCode: this.services.categoryCode,
          productCode: this.services.productCode,
        }
      });
    },
    carChange(data) {
      this.carData = data;
      this.getCity();
      // 清除违章信息，显示查询按钮
      this.carInfoData.violationInfoList = []

      this.showAddCar = false

      this.hasRequestList = false
    },
    goTicketCheck() {
      this.$router.push({
        path: '/ticketCheck',
        query: {
          phone: this.$route.query.phone,
          categoryCode: this.services.categoryCode,
          productCode: this.services.productCode,
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.parkingViolationsCheck{
  width: 100%;
  height: 100vh;

  background: #F4F6F7;

  font-family:'Microsoft YaHei';
  font-size: 0.36rem;
  .carInfo{
    padding: 0.3rem 0.4rem;

    border-top: 0.3rem solid #F4F6F7;
    background: #fff;
    .title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tit{
        color: #383838;

        font-weight: 500;
      }
      .orderList{
        color: #1989fa;

        font-size: 0.3rem;
      }
    }
    .carContent{
      margin-top: 0.3rem;
      padding: 0.3rem;

      background: #F0F4F7;
      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .carNo{
          color: #383838;

          font-size: 0.4rem;
          font-weight: 500;
        }
        .changeCar{
          display: flex;
          align-items: center;

          color: #5986B3;

          font-size: 0.24rem;
          img{
            width: 0.24rem;
            margin-right: 0.05rem;
          }
        }
      }
    }
    .carNum{
      margin-top: 0.4rem;
      .textVal, .textName{
        height: 0.5rem;

        text-align: center;

        color: #383838;

        line-height: 0.6rem;
      }
      .textVal{
        font-weight: 500;
      }
      .textName{
        color: #787878;

        font-size: 0.24rem;
        line-height: 0.7rem;
      }
    }
  }
  .textInfo{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    padding: 0.3rem 0;

    color: #9A9A9A;

    font-size: 0.24rem;
    div{
      width: 100%;

      text-align: center;
      // height: 0.4rem;
      // line-height: 0.15rem;
    }
    .info{
      margin-top: 0.1rem;
    }
  }
  .noData{
    .pic_default{
      display: flex;
      justify-content: center;

      margin: 0.3rem 0;
      img{
        width: 4rem;
      }
    }
    .noDataInfo{
      height: 1rem;

      text-align: center;

      color: #787878;

      font-size: 0.3rem;
      line-height: 1rem;
    }
    .goInfo{
      text-align: center;

      color: #3399FF;

      font-size: 0.3rem;
    }
  }
  .btn{
    position: fixed;
    bottom: 0.3rem;

    box-sizing: border-box;
    width: 100vw;
    padding: 0 0.3rem;
    /deep/ .van-button{
      border-radius: 0.16rem;
    }
  }
  .dataList{
    padding-bottom: 1.2rem;
    .list{
      border-bottom: 0.3rem solid #F4F6F7;
      background: #fff;
      // margin-bottom: 0.3rem;
      .contentHeader{
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 0.24rem 0.4rem;

        border-bottom: 1px solid #F4F6F7;
        .checked{
          // font-size: 0.3rem;
          font-weight: 500;
        }
        .number{
          padding: 0.1rem;

          color: #EA3F26;
          border-radius: 0.07rem;
          background: #FFE9E6;

          font-size: 0.24rem;
        }
      }
    .contentInfo{
      padding: 0.1rem 0.4rem;

      font-size: 0.3rem;
      .textNo, .textVal{
        line-height: 0.6rem;
      }
      .textNo{
        color: #787878;
      }
      .textVal{
        color: #383838;
      }
    }
    }
  }
  .btnBottom{
    position: fixed;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;

    box-sizing: border-box;
    width: 100vw;
    height: 1.2rem;
    padding: 0 0.4rem;

    border-top: 1px solid #F4F6F7;
    background: #fff;

    line-height: 1.2rem;
    /deep/ .van-button{
      width: 2.8rem;
      height: 0.96rem;

      border-radius: 0.16rem;
    }
    .number{
      font-size: 0.3rem;
      span{
        color: #EA3F26;
      }
    }
  }
}
</style>